/**
 * When the one-time name prompt may ask again (components/DisplayNamePrompt).
 * Mirrors mobile `DisplayNamePrompt.cooldown` / `keyPrefix`: three days, kept
 * per member so one member's answer never silences another on a shared device.
 */
export const COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000;
export const KEY_PREFIX = 'wefaqna_display_name_prompt_at:';

/** True when the prompt may be shown again, given when it last was. */
export function isPromptDue(lastShownIso, now = Date.now()) {
  const last = Date.parse(lastShownIso || '');
  return !Number.isFinite(last) || now - last >= COOLDOWN_MS;
}
